<template>
  <div class="business">
    <div class="block">
      <ul>
        <li class="list"  v-for="(item,index) in currenttrade" :key="index"
          :style="`background:url(${item.exp4 && $imgurl + item.exp4.url})0 0 /cover no-repeat`"
        >   
           <p>{{item.title}}</p>
          <p v-html="item.content">
            We6是恒生财富管理产品品牌，We6致力于为各类财富管理机构、资产管理…机构打造财…
          </p>
          <p @click="dow(index)">了解更多</p>
        </li>
      </ul>


      <div class="box" v-show="flg" >
        <div class="page1">
          <img src="../assets/imgapp/gb@2x.png" alt="" @click="sho" />
        </div>
        <div class="page2">{{currenttrade[curindex].title}}</div>
        <div class="page3" v-html="currenttrade[curindex].content">
          恒生经纪业务产品品牌，UF3.0是一站式经纪业务平台，在技术架构、系统解耦、业务设计、接口易用性等方面全面重构，具备“高容量、大并发、低时延”的特点，同时具备水平扩展、松耦合、组件化、快速迭代、灰度发布、弹性资源等特性，将全面助力金融机构经纪业务多元化发展。UF3.0历经七代演进，可支持5万亿-10万亿的行情甚至更大的交易量，是业内公认交易稳定、清算高效的利器。
        </div>
      </div>
    </div>
    <div class="box2" v-show="flg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flg: false,
      currenttrade:[
       {
         title:'',
       }
      ],
      curindex:0
    };
  },
  methods: {
    //数据请求
    getData() {
      this.$fetch({
        url: "index.php/trades/mgetTrades",
      }).then((res) => {
        this.currenttrade = res.data.currenttrade
      });
    },
    //点击隐藏
    sho() {
      this.flg = false;
    },
    //了解更多
    dow(index){
      // window.open(this.$imgurl + url,"_block")
      this.flg = true;
      this.curindex = index
    }
  },
  mounted(){
    this.getData()
  }
};
</script>

<style scoped>
.block {
  background: #ebeef0;
}
.box2 {
  width: 100vw;
  height: 100vh;
  background: #000000;
  opacity: 0.65;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.block .box {
  width: 691px;
  height: 750px;
  background: #fff;
  position: fixed;
  top: 333px;
  left: 30px;
  z-index: 1001;
}
.block .box .page1 {
  position: relative;
}
.block .box .page1 img {
  position: absolute;
  right: 25px;
  top: 23px;
  width: 48px;
  height: 48px;
}
.block .box .page2 {
  width: fit-content;
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  line-height: 50px;
  margin: 64px auto 36px;
}
.block .box .page3 {
  width: 602px;
  height: 546px;
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  margin: 0 auto;
}
.block ul {
  padding: 30px 0 57px;
}
.block ul li {
  margin: 0px auto 30px;
  width: 691px;
  height: 347px;
  background-image: url(../assets/imgapp/we6@2x.png);
  background-size: cover;
  padding-left: 30px;
  padding-top: 43px;
}
.block .list p:nth-child(1) {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}
.block .list p:nth-child(2) {
  width: 361px;
  height: 105px;
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
  margin: 19px 0 50px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.block .list p:nth-child(3) {
  font-size: 28px;
  font-weight: 400;
  color: #396aff;
  line-height: 36px;
  width: fit-content;
}
</style>